function isAdButlerPlacement(placement) {
  return "campaign_id" in placement;
}
function campaignImpression(placement, source) {
  var _a, _b, _c, _d;
  if (!placement) {
    return null;
  }
  if (isAdButlerPlacement(placement)) {
    const setIdMatch = placement.accupixel_url.match(/setID=([0-9]+);/);
    const setId = setIdMatch ? setIdMatch[1] : null;
    return window.digitalDataEvents.push({
      campaignBannerId: placement.banner_id,
      campaignId: placement.campaign_id,
      campaignImp: 1,
      campaignSetId: setId,
      campaignSource: source
    });
  }
  if (!placement.products || !placement.products.length) {
    return window.digitalDataEvents.push({
      campaignImp: 1,
      campaignId: placement.CampaignId,
      campaignSource: source,
      campaignLineItemId: placement.LineItemID
    });
  }
  for (const product of placement.products) {
    window.digitalDataEvents.push({
      campaignImp: 1,
      campaignId: placement.CampaignId || ((_b = (_a = placement == null ? void 0 : placement.products) == null ? void 0 : _a[0]) == null ? void 0 : _b.CampaignId),
      campaignSource: source,
      campaignLineItemId: placement.LineItemID || ((_d = (_c = placement.products) == null ? void 0 : _c[0]) == null ? void 0 : _d.LineItemID),
      sku: product.ProductId,
      pid: product.ParentSKU
    });
  }
}
function campaignClick(placement, source, itemNumber) {
  var _a;
  if (!placement) {
    return null;
  }
  const product = (_a = placement == null ? void 0 : placement.products) == null ? void 0 : _a.find((p) => p.ParentSKU === itemNumber);
  window.digitalDataEvents.push({
    espot: placement.format,
    campaignClick: 1,
    campaignId: placement.CampaignId || (product == null ? void 0 : product.CampaignId),
    campaignSource: source,
    campaignLineItemId: placement.LineItemID || (product == null ? void 0 : product.LineItemID),
    sku: product == null ? void 0 : product.ProductId,
    pid: product == null ? void 0 : product.ParentSKU
  });
}
export {
  campaignClick,
  campaignImpression,
  isAdButlerPlacement
};
